import { http } from "@/providers/http";
import { utils } from "@/utils/utils";
import { CprsEndorsementPayload } from "@/models/cprs-endorsement-application/cprs-endorsement-application.interface";

export class CprsEndorsementApplicationApi {
  private static INSTANCE = new CprsEndorsementApplicationApi();

  static get instance(): CprsEndorsementApplicationApi {
    return this.INSTANCE;
  }

  private buildData(payLoadData: CprsEndorsementPayload, fillStatus: string) {
    const userDetails = utils.getUserDetails();
    return {
      fillStatus,
      data: {
        endorsementBasicDetails: payLoadData.cprsJBasicDetails,
        endorsementJusticeInvolvement: payLoadData.cprsJQuestions,
        endorsementSignature: payLoadData.cprsJSignature,
      },
      submittedBy: userDetails?.userId,
    };
  }

  public submitCprsEndorsementApplication(
    payLoadData: CprsEndorsementPayload,
    fillStatus: string
  ): Promise<any> {
    const endpoint = "cprs/endorsement";
    const headers = http.getTokenHeaders();
    // No id is sent — the backend generates its own on insert and returns the
    // acknowledgement code in the response body.
    const data = this.buildData(payLoadData, fillStatus);
    return http.post(endpoint, headers, data);
  }

  public updateCprsEndorsementApplication(
    payLoadData: CprsEndorsementPayload,
    fillStatus: string
  ): Promise<any> {
    const endpoint = `cprs/endorsement?id=${payLoadData.id}`;
    const headers = http.getTokenHeaders();
    const data = {
      id: payLoadData.id,
      ...this.buildData(payLoadData, fillStatus),
    };
    return http.put(endpoint, headers, data);
  }

  public getCprsEndorsementApplication(id: string): Promise<any> {
    const endpoint = `cprs/endorsement`;
    const params = { id };
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params);
  }

  public getCprsEndorsementApplicationByEmail(email: string): Promise<any> {
    const endpoint = `cprs/endorsement/details`;
    const params = { email };
    const headers = http.getTokenHeaders();
    return http.get(endpoint, headers, params);
  }
}

export const cprsEndorsementApplicationApi =
  CprsEndorsementApplicationApi.instance;
